import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  QuestionCheckbox,
  QuestionCurrency,
  QuestionDate,
  QuestionDependentDropdown,
  QuestionDropdown,
  QuestionMonth,
  QuestionNumber,
  QuestionPercent,
  QuestionWithAttachments,
  QuestionRadioButton,
  QuestionRelation,
  QuestionSmileyRating,
  QuestionStarRating,
  QuestionTable,
  QuestionText,
  QuestionTime,
  QuestionYear
} from 'src/components/JobDatasheet';

const questionTypeMapping = {
  checkbox: QuestionCheckbox,
  currency: QuestionCurrency,
  date: QuestionDate,
  dropdown: QuestionDropdown,
  dependentDropdown: QuestionDependentDropdown,
  month: QuestionMonth,
  number: QuestionNumber,
  percent: QuestionPercent,
  picture: QuestionWithAttachments,
  radioButton: QuestionRadioButton,
  relation: QuestionRelation,
  smileyRating: QuestionSmileyRating,
  starRating: QuestionStarRating,
  table: QuestionTable,
  text: QuestionText,
  time: QuestionTime,
  voice: QuestionWithAttachments,
  year: QuestionYear,
};

const QuestionResponseSection = props => {
  const { results, datasheet } = props;

  const { t } = useTranslation();
  const questions = datasheet?.currentVersion?.survey?.surveyData?.questions || [];

  const getQuestionResult = (datasheetQuestionId) => {
    const res = (results || []).find(result => result.datasheetQuestionId === datasheetQuestionId);
    if (res) {
      return res.result;
    }
    return null;
  };

  const getResult = ({ datasheetQuestionId }) => {
    const res = (results || []).find(result => result.datasheetQuestionId === datasheetQuestionId);
    if (res) {
      return { result: res.result };
    }
    return null;
  };

  return (
    questions.map(question => {
      const QuestionTypeForm = questionTypeMapping[question.questionType];
      if (!QuestionTypeForm) {
        return null;
      }
      return (
        <>
          <p>{t('QUESTION')} {question.questionNumber}. {question.text}</p>
          <QuestionTypeForm
            key={`surveyQuestionResponse-${question.id}`}
            allQuestions={questions}
            disabled={true}
            getResult={getResult}
            onChange={()=>{}}
            question={question}
            isSurvey={false}
            disableChange={false}
            value={getQuestionResult(question.datasheetQuestionId) || null}/>
        </>
      );
    })
  );
};

export default React.memo(QuestionResponseSection);
